import React from 'react'

// components
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const EditButton = props => {
  const { emergencyContact, reupRequired, align } = props
  const path = `/emergency_contacts/${emergencyContact.id}/edit`
  const color =
    reupRequired && emergencyContact.confirmed ? 'primary' : 'secondary'

  return (
    <ResponsiveButton to={path} color={color} align={align}>
      {emergencyContact.confirmed ? 'Edit' : 'Confirm'}
    </ResponsiveButton>
  )
}

export default EditButton
